import { useEffect, useState } from "react";
import useApi from "../../api";
import { NXDelete } from "../../icons";
import { useDeleteConfirmation } from "../common";
import NxtbnDrawer from "../drawer"
import AddressForm from "./address/AddressForm";
import { handleRetriveError } from "../../utils";


interface PropsTypes {
  id?: number;
  isOpen: boolean;
  onClose: () => void;
}

function CustomerDetails({id, isOpen, onClose}:PropsTypes) {
  const [customer, setCustomer] = useState<any>(null)
  const [openAddressForm, setOpenAddressForm] = useState<boolean>(false)
  const [edit, setEdit] = useState<any>(null)

  const {handleDelete} = useDeleteConfirmation()
  const api = useApi()

  const fetchCustomerDetails = () => {
    api.getCustomerDetails(id).then((response:any)=>{
      setCustomer(response)
    }, handleRetriveError)
  }

  useEffect(()=>{
    fetchCustomerDetails()
  }, [id])


  return (
    <NxtbnDrawer size="md" title="Customer Details" isOpen={isOpen} onClose={onClose}>
      <div>
        <div>
          <h3 className="mb-4">Customer Info</h3>
          <div className="p-4 border shadow-lg rounded-lg mb-4">
            <div><strong>First Name: </strong>{customer?.first_name}</div>
            <div><strong>Last Name: </strong>{customer?.last_name}</div>
            <div><strong>Username: </strong>{customer?.username}</div>
            <div><strong>Email: </strong>{customer?.email}</div>
            <div><strong>Role: </strong>{customer?.role}</div>
          </div>
        </div>
        <div>
          <div className="flex justify-between items-center mb-4 mt-4">
            <h3>Address</h3>
            <button
              onClick={()=>setOpenAddressForm(!openAddressForm)} 
              className="bg-primary-600 py-1 px-4 rounded-md text-white hover:bg-primary-400 transition-all duration-150 ease-linear"
            >
              + Add Address
            </button>
          </div>
          <div>
            {customer?.addresses?.map((item:any, index:number)=>(
              <div key={index} className="p-4 border shadow-lg rounded-lg mb-4 flex justify-between items-start">
                <div>
                  <div><strong>First Name: </strong>{item?.first_name}</div>
                  <div><strong>Last Name: </strong>{item?.last_name}</div>
                  <div><strong>Email:  </strong>{item?.email_address}</div>
                  <div><strong>Phone Number </strong>{item?.phone_number}</div>

                  <div><strong>Street Address: </strong>{item?.street_address}</div>
                  <div><strong>City: </strong>{item?.city}</div>
                  <div><strong>State: </strong>{item?.state}</div>
                  <div><strong>Postal Code: </strong>{item?.postal_code}</div>
                  <div><strong>Country: </strong>{item?.country}</div>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={()=>setEdit(item)}
                    className="text-primary-400 hover:underline font-bold"
                  >
                    Edit
                  </button>
                  <button 
                    onClick={(e)=>{
                      e.preventDefault()
                      handleDelete(
                        item.id,
                        "Address",
                        api.deleteAddress,
                        fetchCustomerDetails
                      )
                    }}
                  >
                    <NXDelete className="text-red-600"/>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {openAddressForm && 
        <AddressForm 
          userId={customer?.id}
          isOpen={openAddressForm} 
          onClose={()=>setOpenAddressForm(false)}
          refresh={fetchCustomerDetails}
        />
      }

      {edit && 
        <AddressForm 
          edit={edit} 
          isOpen={edit ? true : false} 
          onClose={()=>setEdit(null)}
          refresh={fetchCustomerDetails}
        />}
    </NxtbnDrawer>
  )
}

export default CustomerDetails